/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */

import React, { useEffect, useState } from 'react'
import CustomTriggerConditionComponent, { ICustomTriggerCondition, LogicalOperators } from './CustomTriggerConditionComponent';
import './TriggerPointSidePopover.css'
import { cloneDeep, isEqual } from 'lodash';
import { Icon } from '../../../globalUtils/globalIcons';
import CustomChartPopup from '../../softwareReleaseManagement/dashboard/CustomChartPopup';
import AddLogicalExpression from './AddLogicalExpression';
import { ExecutionPlan } from './ExecutionPlan';
import { CustomButtonGroup } from '../../../globalUtils/globalExports';


export const operators = ['(',')','AND','OR'];
export const isOperator = (token: string) => operators?.includes(token);


interface TriggerPointSidePopoverProps {
    executionPlan: ExecutionPlan;
    handleUpdateExecutionPlan: Function;
    handleClose: Function;
}

const TriggerPointSidePopover:React.FC<TriggerPointSidePopoverProps> = (props) => {
 
  const { executionPlan, handleUpdateExecutionPlan, handleClose } = props;

//   const [conditionCount,setConditionCount] = useState<number>(0);
  const [logicalExpression,setLogicalExpression] = useState<string | null>(executionPlan?.trigger?.expression);
  const [conditions,setConditions] = useState<ICustomTriggerCondition[]>(executionPlan?.trigger?.conditions);
  const [showEditScreen, setShowEditScreen] = useState<boolean>(false);

  const handleConditionUpdate = (conditionLabel:string, condition: ICustomTriggerCondition) => {
    const allConditions = conditions.map(item => item.triggerCondName === conditionLabel ? condition : item);
    setConditions(allConditions);
  }

  const updateLogicalExpression = (conditions: ICustomTriggerCondition[]) => {
    if(!conditions || conditions.length === 0)return;
    if(!logicalExpression){
        setLogicalExpression('A');
    }
    else {
        const tokens = logicalExpression?.split(' ');
        const operators = tokens?.filter(item => item === 'AND' || item === 'OR');
        conditions.forEach((condition,idx) => {
            if(idx === 0)return;
            else {
                if(idx > operators.length) {
                    operators.push('AND');
                    tokens.push('AND');
                    tokens.push(condition?.triggerCondName);
                }
                else operators[idx-1] = condition?.connective as LogicalOperators;
            }
        })
        let i = 0;
        const updatedTokens = tokens.map(token => {
            if (token === 'AND' || token === 'OR') {
                return operators[i++];
            }
            else return token;
        })

        setLogicalExpression(updatedTokens?.join(' '));
    }
  }

  const generateCondition = (conditionLabel:string,connectiveValue: LogicalOperators | null)=>{
    const connective = connectiveValue;
    const condition =  {
        triggerCondName: conditionLabel,
        triggerParamId: null,
        triggerParamLabel: null,
        triggerParamType: null,
        triggerParamLevel: null,
        triggerOperator: null,
        triggerParameter1Value: null,
        triggerParameter2Value: null,
        isTriggerParamTypeEnum: false,
        triggerParamEnumValue: [],
        triggerParamUnit: null,
        isTriggerParamTypeDate: false,
        isDerived: false,

        connectorType: null,
        connectorScope: null,

        arithmeticParamId: null,
        arithmeticParamLabel: null,
        arithmeticParamType: null,
        arithmeticParamLevel: null,
        arithmeticOperator:  null ,
        arithmeticParamValue: null,
        arithmeticParamUnit: null,
        arithmeticParamConnectorType: null,

        connective: connective,

        errorMessage: null,
        errorMessageSecondary: null,
        errorMessageArithmeticParam: null
    }
    return condition;
  }

  const getUsedConditions = (tokens: string[]) => new Set(tokens.filter(t => !isOperator(t)));
  const getNextConditionLabel = (tokens: string[]) => {
    const used = getUsedConditions(tokens)

    for (let i = 0; i < 26; i++) {
        const label = String.fromCharCode(65 + i)
        if (!used.has(label)) {
            return label;
        }
    }

    return null;
  }

  const addCondition = () => {
    const tokens = logicalExpression ? logicalExpression?.split(' ') : [];
    const nextCondition = getNextConditionLabel(tokens);
    if(!nextCondition)return;
    const condition = generateCondition(nextCondition,'AND');
    // setConditionCount(prev=>prev+1);
    setConditions(prev=>[...prev,condition]);
  }

  useEffect(()=>{
    updateLogicalExpression(conditions);
  },[conditions])


  const handleUpdateLogicalExpression = (tokens: string[]) => {
    const conditionLabels = tokens?.filter(token => !operators?.includes(token));
    const connectives = tokens?.filter(token=> token === 'AND' || token === 'OR' );
    const updatedConditions:ICustomTriggerCondition[] = conditionLabels.map((label,conditionIdx) => {
        const condition = conditions?.filter(item => item?.triggerCondName === label)?.[0];
        const connective = conditionIdx == 0 ? 'AND' : connectives?.[conditionIdx - 1];
        if(!condition) {
            const data = generateCondition(label,connective);
            return data;
        } 
        const data = cloneDeep(condition);
        data.connective = connective;
        return data;
    })

    // setConditionCount(conditionLabels?.length);
    setConditions(updatedConditions);
    setLogicalExpression(tokens?.join(' '))

  }

  const disableButton = () => {
    if(isEqual(conditions,executionPlan.trigger.conditions)) return true;
    if(!logicalExpression || logicalExpression?.trim() === '')return true;
    
    return conditions?.some(condition => {
        if(condition?.isDerived)return false;
        if( (!condition?.arithmeticParamId && condition?.errorMessage) || ((condition?.triggerOperator === 'between' || condition?.triggerOperator === 'notBetween')  && condition?.errorMessageSecondary) || (condition?.arithmeticParamId && condition?.errorMessageArithmeticParam)){
            return true;
        }
        else if (!condition?.triggerParamId || !condition?.triggerOperator) return true;
        else if ((condition?.triggerOperator === 'between' || condition?.triggerOperator === 'notBetween') && (!condition?.triggerParameter1Value || !condition?.triggerParameter2Value)) return true;
        else if (condition?.isTriggerParamTypeEnum && (!condition?.triggerParamEnumValue || condition?.triggerParamEnumValue?.length === 0)) return true;
        else if (!condition?.isTriggerParamTypeEnum && !condition?.triggerParameter1Value && (!condition?.arithmeticParamId || !condition?.arithmeticOperator || !condition?.arithmeticParamValue)) return true;
        return false;
    })
  } 


  const btnsList = [
    {
        buttonText: 'Save',
        buttonId: 'add',
        btnClassName:  disableButton() ? 'primary__btn disabled' : 'primary__btn',
        handleClick: (): void => {
                const data = cloneDeep(executionPlan);
                data.trigger.conditions = conditions,
                data.trigger.expression = logicalExpression;
                if(data.trigger.conditions?.length !== 1 || data.trigger?.conditions?.[0]?.triggerParamType !== 'SESSION'){
                    data.trigger.isConsecutive = null;
                }
                handleUpdateExecutionPlan(data);
                handleClose();
        },
        isDisabled: disableButton(),
        buttonVariant: 'filled',
    },
    {
        buttonText: 'Cancel',
        buttonId: 'cancel',
        btnClassName: 'secondary__btn',
        handleClick: (): void => {
            handleClose()
        },
        isDisabled: false,
        buttonVariant: 'outlined',
    }
  ]

  return (
    <>
        <div className='advance__rule__engine__trigger__point__side__popover__container'>
            <div className='advance__rule__engine__trigger__point__side__popover-logical-expression-container'>
                <div className='advance__rule__engine__trigger__point__side__popover-logical-expression-container-left'>
                    <div className='advance__rule__engine__trigger__point__side__popover-logical-expression-label'>
                        Logical Expression:
                    </div>
                    <div className='advance__rule__engine__trigger__point__side__popover-logical-expression-value'>
                        {logicalExpression}
                    </div>
                </div>
                <div className = 'advance__rule__engine__trigger__point__side__popover-logical-expression-value-edit'>
                    <Icon iconClassName='rms__pencil__icon' onIconClick={() => setShowEditScreen(true)}/>
                </div>
            </div>
            <div className='advance__rule__engine__trigger__point__side__popover-condition-container'>
                {
                    conditions && conditions?.length > 0 && conditions.map((condition,idx) => {
                        const showSessionNote = conditions?.length === 1;
                        return <CustomTriggerConditionComponent key={condition?.triggerCondName} condition={condition} handleConditionUpdate={handleConditionUpdate} position={idx} showSessionNote={showSessionNote}/>
                    })
                }
            </div>
            <div className='advance__rule__engine__trigger__point__side__popover-add-condition-btn'
                onClick={addCondition}
            >
                <Icon iconClassName='rms__table__dashboard__add__new__btn'/>
                <div className='advance__rule__engine__trigger__point__side__popover-add-condition-btn-label'>Conditions</div>
            </div>
        </div>
        <div className='advance__rule__engine__side__popover-footer'>
            <CustomButtonGroup
                buttonsList={btnsList}
                buttonGroupClassName='button__group__footer' 
            />
        </div>
        <CustomChartPopup 
            show={showEditScreen}       
        >
            <AddLogicalExpression handleUpdateLogicalExpression={handleUpdateLogicalExpression} handleClose = {()=>{setShowEditScreen(false)}} logicalExpression={logicalExpression} />
        </CustomChartPopup>
    </>
  )
}

export default TriggerPointSidePopover